import { render, staticRenderFns } from "./forex-banner.vue?vue&type=template&id=ed7eae1a&scoped=true"
import script from "./forex-banner.vue?vue&type=script&lang=js"
export * from "./forex-banner.vue?vue&type=script&lang=js"
import style0 from "./forex-banner.vue?vue&type=style&index=0&id=ed7eae1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7eae1a",
  null
  
)

export default component.exports